import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@ths/ui";
import { Outline } from "@ths/ui/icons";
import type { RefObject } from "react";

interface GuestAccountMenuProps {
  guestName?: string;
  onSignOut: () => void;
  onSettings?: () => void;
  triggerRef?: RefObject<HTMLButtonElement>;
}

export default function GuestAccountMenu({
  guestName,
  onSignOut,
  onSettings,
  triggerRef,
}: GuestAccountMenuProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          ref={triggerRef}
          type="button"
          variant="ghost"
          aria-label="Account"
          className="size-11 shrink-0 rounded-full p-0 text-on-navy/90 hover:bg-on-navy/10 focus-visible:ring-on-navy focus-visible:ring-offset-navy-strong data-[state=open]:bg-on-navy/10"
        >
          <Outline.UserCircleIcon className="size-6" aria-hidden="true" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        aria-label="Account"
        collisionPadding={16}
        className="w-56 max-w-[calc(100vw-2rem)] border border-on-navy/20 bg-navy-strong text-on-navy"
      >
        <DropdownMenuLabel className="whitespace-normal break-words p-3 text-body font-medium text-on-navy">
          {guestName?.trim() || "Account"}
        </DropdownMenuLabel>
        <DropdownMenuSeparator className="bg-on-navy/15" />
        {onSettings && (
          <DropdownMenuItem
            onSelect={onSettings}
            className="min-h-11 px-3 text-on-navy data-[highlighted]:bg-on-navy/10"
          >
            Settings
          </DropdownMenuItem>
        )}
        <DropdownMenuItem
          onSelect={onSignOut}
          className="min-h-11 px-3 text-on-navy data-[highlighted]:bg-on-navy/10"
        >
          Sign out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
